import React, {FunctionComponent, useContext} from 'react';
import styled from "styled-components";
import {ThemeContext} from "../../context/ThemeContext";
import {Theme} from "../../models/theme.model";

interface UserAvatarProps {
    initials: string;
    avatar: string
}

const Avatar = styled.img`
  &&& {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    object-fit: cover;
    border: 2px solid ${props => props.theme.branding_light_color};
  }
`;
const Initials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background: ${props => props.theme.branding_color};
  color: ${props => props.theme.text_contrast_color};
`;

export const UserAvatar: FunctionComponent<UserAvatarProps> = (props) => {
    const {initials, avatar} = props;
    const theme: Theme = useContext(ThemeContext).theme;

    const renderAvatar = () => {
        return <Avatar theme={theme} alt={'User Avatar'} src={avatar}></Avatar>
    }

    const renderInitials = () => {
        return <Initials theme={theme}>{initials}</Initials>
    }


    return (
        <div className='user-avatar'>
            {avatar ? renderAvatar() : renderInitials()}
        </div>
    );
};